import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RecipeService } from '../recipe.service';
import { Recipe } from '../recipe.model';

@Component({
    selector: 'app-recipe-list',
    templateUrl: './recipe-list.component.html',
    styleUrls: ['./recipe-list.component.scss'],
    standalone: false
})
export class RecipeListComponent implements OnInit, OnDestroy {
  recipes: Recipe[] = [];
  allFeelings: string[] = [];
  selectedFeeling: string | null = null;
  filteredRecipes: Recipe[] = [];
  browseAll = false;

  showFormModal = false;
  editingRecipe: Recipe | null = null;

  private recipesSub?: Subscription;

  constructor(private recipeService: RecipeService) {}

  get showGrid(): boolean {
    return this.recipes.length > 0 && (this.selectedFeeling !== null || this.browseAll);
  }

  get showPrompt(): boolean {
    return this.recipes.length > 0 && this.selectedFeeling === null && !this.browseAll;
  }

  ngOnInit() {
    this.recipesSub = this.recipeService.getRecipes().subscribe(recipes => {
      this.recipes = recipes;
      this.allFeelings = this.computeAllFeelings(recipes);
      this.filteredRecipes = this.computeFilteredRecipes();
    });
  }

  ngOnDestroy() {
    this.recipesSub?.unsubscribe();
  }

  private computeAllFeelings(recipes: Recipe[]): string[] {
    const seen = new Set<string>();
    recipes.forEach(r => r.feelings.forEach(f => seen.add(f)));
    return Array.from(seen).sort();
  }

  private computeFilteredRecipes(): Recipe[] {
    if (!this.selectedFeeling) return this.recipes;
    return this.recipes.filter(r => r.feelings.includes(this.selectedFeeling!));
  }

  selectFeeling(feeling: string) {
    this.selectedFeeling = this.selectedFeeling === feeling ? null : feeling;
    this.browseAll = false;
    this.filteredRecipes = this.computeFilteredRecipes();
  }

  browseAllRecipes() {
    this.browseAll = true;
    this.selectedFeeling = null;
    this.filteredRecipes = this.recipes;
  }

  clearFilter() {
    this.selectedFeeling = null;
    this.browseAll = false;
    this.filteredRecipes = this.computeFilteredRecipes();
  }

  openAddModal() {
    this.editingRecipe = null;
    this.showFormModal = true;
  }

  onFormSaved() {
    this.showFormModal = false;
    this.editingRecipe = null;
  }

  onFormCancelled() {
    this.showFormModal = false;
    this.editingRecipe = null;
  }
}
